import type { GetAdminV1StoresStoreIdAnalyticsSummaryParams } from '@nucleus-commerce/api-client/admin';

import type { EventListParams } from '../api/analytics-api';

/** Store-scoped keys: switching stores never shares cache. */
export const analyticsKeys = {
  all: (storeId: string) => ['stores', storeId, 'analytics'] as const,
  destinations: (storeId: string) => [...analyticsKeys.all(storeId), 'destinations'] as const,
  summary: (storeId: string, params: GetAdminV1StoresStoreIdAnalyticsSummaryParams) =>
    [...analyticsKeys.all(storeId), 'summary', params] as const,
  events: (storeId: string, params: EventListParams) =>
    [...analyticsKeys.all(storeId), 'events', params] as const,
};
